import React, { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { ConfigStore } from '../store/configStore'
import { UserStore } from '../store/userStore'
import { IUserSocial } from '../server/user/get'
import Btn from './Btn'

const SocialsConnection = observer(() => {
  const vendors = useMemo(
    () => ConfigStore.privateConfig?.socialsVendors || [],
    [ConfigStore.privateConfig]
  )

  const userSocials = useMemo<{ [key: string]: IUserSocial }>(() => {
    const userSocials = UserStore.data?.socials || []

    return userSocials.reduce(
      (acc: { [key: string]: IUserSocial }, userSocial: IUserSocial) => {
        const hasVendor = vendors.find(({ id }) => id === userSocial.id)

        if (hasVendor) {
          acc[userSocial.id] = userSocial
        }

        return acc
      },
      {}
    )
  }, [ConfigStore.privateConfig, UserStore.data])

  return (
    <div className={'socials-connection'}>
      {vendors.length ? (
        vendors.map(({ id, icon, name, href }) => (
          <div key={id} className={'socials-connection-item'}>
            <div className={'socials-connection-item__label'}>
              <div className={'socials-connection-item__icon'}>
                <img src={icon} alt={name} />
              </div>
              <p className={'socials-connection-item__name text-body-bold'}>
                {name}
              </p>
            </div>
            <div className={'socials-connection-item__actions'}>
              {userSocials[id as string] ? (
                <Btn
                  target={userSocials[id as string].href ? '_blank' : undefined}
                  rel={
                    userSocials[id as string].href
                      ? 'noopener noreferrer'
                      : undefined
                  }
                  outlined
                  style={{
                    pointerEvents: userSocials[id as string].href
                      ? 'all'
                      : 'none'
                  }}
                  href={userSocials[id as string].href || undefined}
                >
                  {userSocials[id as string].text}
                </Btn>
              ) : (
                <Btn href={href}>Подключить</Btn>
              )}
            </div>
          </div>
        ))
      ) : (
        <p className={'text-body-small text-secondary-color'}>
          Нет доступных соцсетей для подключения
        </p>
      )}
    </div>
  )
})

export default SocialsConnection
